import { getFormattedMessage } from "../../../components/shared_components_registration"

export const rightPanelRegistration = (isLTPM) => ({
  headerRowStyle: isLTPM
    ? { backgroundColor: "var(--ltpm-blue-primary)" }
    : {
        backgroundColor: "var(--lanzalake-blue-primary)",
        color: "var(--lanzalake-white)",
      },
  headerColStyle: isLTPM ? { borderRight: "1px solid var(--lanzalake-blue-bright)" } : {},
  colValueStyle: {
    padding: "1px",
    marginBottom: "1px",
    marginTop: "1px",
    wordWrap: "breakWord",
  },
  errMsg: (intl) => getFormattedMessage("general.server.error", "Error loading Run details", true, intl),
  noActiveRuns: (intl) =>
    getFormattedMessage("livedash.no.active.runs", "There are no active runs in system", true, intl),
})

const DEFAULT_SITE_METRICS = [
  {
    tag: "UCO",
    units: "pct",
  },
  {
    tag: "UH2",
    units: "pct",
  },
  {
    tag: "UCO2",
    units: "pct",
  },
  {
    tag: "Ethanol",
    units: "g/L",
  },
  {
    tag: "Acetate",
    units: "g/L",
  },
  {
    tag: "BDO",
    units: "g/L",
  },
  {
    tag: "OD",
    units: "g/L",
  },
  {
    tag: "OD_probe",
    units: "g/L",
  },
  {
    tag: "VIABLE_BIOMASS_Probe",
    units: "g/L",
  },
  {
    tag: "DCW",
    units: "g/L",
  },
  {
    tag: "Lactate",
    units: "g/L",
  },
  {
    tag: "pH",
    units: "pH",
  },
  {
    tag: "QG_VOL_FLOW",
    units: "Nm3/hr",
  },
  {
    tag: "QG",
    units: "kg/hr",
  },
  {
    tag: "AF",
    units: "mL/hr",
  },
  {
    tag: "AFPPM",
    units: "ppm",
  },
  {
    tag: "qCO",
    units: "mol/g/day",
  },
  {
    tag: "CO_Uptake",
    units: "mmol/L/day",
  },
  {
    tag: "H2_Uptake",
    units: "mmol/L/day",
  },
  {
    tag: "CO2_Uptake",
    units: "mmol/L/day",
  },
  {
    tag: "Dw",
    units: "1/day",
  },
  {
    tag: "Din",
    units: "1/day",
  },
  {
    tag: "Dout",
    units: "1/day",
  },
  {
    tag: "IN_CO",
    units: "pct",
  },
  {
    tag: "IN_H2",
    units: "pct",
  },
  {
    tag: "IN_N2",
    units: "pct",
  },
  {
    tag: "IN_CO2",
    units: "pct",
  },
  {
    tag: "IN_CH4",
    units: "pct",
  },
  {
    tag: "CW",
    units: "m3/hr",
  },
  {
    tag: "DRW",
    units: "m3/hr",
  },
  {
    tag: "XMED",
    units: "L/hr",
  },
  {
    tag: "NaSH",
    units: "L/hr",
  },
  {
    tag: "KOH",
    units: "L/hr",
  },
  {
    tag: "Bleed",
    units: "m3/hr",
  },
  {
    tag: "Permeate",
    units: "m3/hr",
  },
  {
    tag: "KO_Pot_dP",
    units: "kPa",
  },
  {
    tag: "KO_Pot_Lvl",
    units: "m",
  },
  {
    tag: "CRM1 P_IN",
    units: "bar",
  },
  {
    tag: "CRM1 P_PMT_L",
    units: "bar",
  },
]

const DEFAULT_SEED_METRICS = [
  {
    tag: "UCO",
    units: "pct",
  },
  {
    tag: "UH2",
    units: "pct",
  },
  {
    tag: "UCO2",
    units: "pct",
  },
  {
    tag: "Agit",
    units: "rpm",
  },
  {
    tag: "Temp",
    units: "°C",
  },
  {
    tag: "ORP",
    units: "mV",
  },
  {
    tag: "Ethanol",
    units: "g/L",
  },
  {
    tag: "Acetate",
    units: "g/L",
  },
  {
    tag: "BDO",
    units: "g/L",
  },
  {
    tag: "Lactate",
    units: "g/L",
  },
  {
    tag: "DCW",
    units: "g/L",
  },
  {
    tag: "pH",
    units: "pH",
  },
  {
    tag: "QG_VOL_FLOW",
    units: "nccm",
  },
  {
    tag: "QG",
    units: "g/hr",
  },
  {
    tag: "IN_CO",
    units: "pct",
  },
  {
    tag: "IN_H2",
    units: "pct",
  },
  {
    tag: "IN_N2",
    units: "pct",
  },
  {
    tag: "IN_CO2",
    units: "pct",
  },
  {
    tag: "IN_CH4",
    units: "pct",
  },
  {
    tag: "qCO",
    units: "mol/g/day",
  },
  {
    tag: "CO_Uptake",
    units: "mmol/L/day",
  },
  {
    tag: "H2_Uptake",
    units: "mmol/L/day",
  },
  {
    tag: "CO2_Uptake",
    units: "mmol/L/day",
  },
  {
    tag: "Dw",
    units: "1/day",
  },
  {
    tag: "Din",
    units: "1/day",
  },
  {
    tag: "Dout",
    units: "1/day",
  },
  {
    tag: "Liquid_Volume",
    units: "L",
  },
  {
    tag: "VL",
    units: "L",
  },
  {
    tag: "XMED",
    units: "L/day",
  },
  {
    tag: "Bleed",
    units: "L/day",
  },
  {
    tag: "Permeate",
    units: "L/day",
  },
]

const JV_PRESET_METRICS = DEFAULT_SITE_METRICS.filter(
  (t) => !["OD_probe", "VIABLE_BIOMASS_Probe"].includes(t.tag),
)

// Default metrics shown in KPI panel on live dashboard
export const PRESET_METRICS = {
  "*": DEFAULT_SITE_METRICS,
  Skokie_HPLC: [
    {
      tag: "Ethanol",
      units: "g/L",
    },
    {
      tag: "Acetate",
      units: "g/L",
    },
    {
      tag: "BDO",
      units: "g/L",
    },
    {
      tag: "Lactate",
      units: "g/L",
    },
    {
      tag: "Phosphate",
      units: "g/L",
    },
    {
      tag: "3-HB",
      units: "g/L",
    },
    {
      tag: "Acetone",
      units: "g/L",
    },
    {
      tag: "Citramalate",
      units: "g/L",
    },
    {
      tag: "Isopropanol",
      units: "g/L",
    },
    {
      tag: "1-2-Propanediol",
      units: "g/L",
    },
    {
      tag: "Ret_Ethanol",
      units: "minute",
    },
    {
      tag: "Ret_Acetate",
      units: "minute",
    },
    {
      tag: "Ret_BDO",
      units: "minute",
    },
    {
      tag: "Ret_Lactate",
      units: "minute",
    },
    {
      tag: "Ret_Phosphate",
      units: "minute",
    },
    {
      tag: "Ret_3-Hydroxybutyric Acid",
      units: "minute",
    },
    {
      tag: "Ret_Acetone",
      units: "minute",
    },
    {
      tag: "Ret_Citramalate",
      units: "minute",
    },
    {
      tag: "Ret_Isopropanol",
      units: "minute",
    },
    {
      tag: "Ret_1-2-Propanediol",
      units: "minute",
    },
  ],
  "Skokie_BioFoundry 2": [
    {
      tag: "OUT_CO",
      units: "pct",
    },
    {
      tag: "OUT_CO2",
      units: "pct",
    },
    {
      tag: "OUT_O2",
      units: "pct",
    },
    {
      tag: "OUT_H2",
      units: "pct",
    },
    {
      tag: "OUT_N2",
      units: "pct",
    },
    {
      tag: "OUT_CH4",
      units: "pct",
    },
  ],
  Shoulang: JV_PRESET_METRICS,
  Shougang: JV_PRESET_METRICS,
  "Shougang II": JV_PRESET_METRICS,
  "BinZe Technology": JV_PRESET_METRICS,
  "Guizhou Jinze": JV_PRESET_METRICS,
  "AM Ghent": [
    {
      tag: "QG_VOL_FLOW",
      units: "Nm3/hr",
    },
    {
      tag: "P_Head1",
      units: "barg",
    },
    {
      tag: "Ethanol",
      units: "g/L",
    },
    {
      tag: "Acetate",
      units: "g/L",
    },
    {
      tag: "Lactate",
      units: "g/L",
    },
    {
      tag: "OD",
      units: "g/L",
    },
    {
      tag: "OD_probe",
      units: "g/L",
    },
    {
      tag: "VIABLE_BIOMASS_Probe",
      units: "g/L",
    },
    {
      tag: "Dw",
      units: "1/day",
    },
    {
      tag: "Din",
      units: "1/day",
    },
    {
      tag: "Dout",
      units: "1/day",
    },
    {
      tag: "UCO",
      units: "pct",
    },
    {
      tag: "UH2",
      units: "pct",
    },
    {
      tag: "CO_Uptake",
      units: "mmol/L/day",
    },
    {
      tag: "H2_Uptake",
      units: "mmol/L/day",
    },
    {
      tag: "Level",
      units: "m",
    },
    {
      tag: "VL",
      units: "m3",
    },
    {
      tag: "eD",
      units: "pct",
    },
    {
      tag: "eRM",
      units: "pct",
    },
    {
      tag: "eS",
      units: "pct",
    },
    {
      tag: "pH",
      units: "pH",
    },
    {
      tag: "pH_BR",
      units: "pH",
    },
    {
      tag: "pH_TR",
      units: "pH",
    },
  ],
  LNP: [
    {
      tag: "Ethanol",
      units: "g/L",
    },
    {
      tag: "Acetate",
      units: "g/L",
    },
    {
      tag: "Phosphate",
      units: "g/L",
    },
    {
      tag: "3-HB",
      units: "g/L",
    },
    {
      tag: "OD",
      units: "g/L",
    },
    {
      tag: "DCW",
      units: "g/L",
    },
    {
      tag: "OD_probe",
      units: "g/L",
    },
    {
      tag: "O2_Uptake",
      units: "mmol/L/day",
    },
    {
      tag: "CO2_Uptake",
      units: "mmol/L/day",
    },
    {
      tag: "H2_Uptake",
      units: "mmol/L/day",
    },
    {
      tag: "VL",
      units: "L",
    },
    {
      tag: "eR",
      units: "pct",
    },
    {
      tag: "eD",
      units: "pct",
    },
    {
      tag: "AF_Dose_Count",
      units: "counts",
    },
    {
      tag: "DO_Downcomer_Bottom",
      units: "mg/L",
    },
    {
      tag: "DO_Downcomer_Top",
      units: "mg/L",
    },
    {
      tag: "DO_Riser_Bottom",
      units: "mg/L",
    },
    {
      tag: "DO_Riser_Top",
      units: "mg/L",
    },
    {
      tag: "DO_Separator_Bottom",
      units: "mg/L",
    },
    {
      tag: "Loop FB",
      units: "pct",
    },
    {
      tag: "Shower FB",
      units: "pct",
    },
    {
      tag: "Vent_OT_A",
      units: "pct",
    },
    {
      tag: "Vent_OT_B",
      units: "pct",
    },
  ],
  "Freedom Pines": DEFAULT_SITE_METRICS.map((t) => {
    if (t["tag"] === "NaSH") {
      return {
        ...t,
        tag: "Sulfur",
      }
    } else {
      return t
    }
  }),
  ...Object.fromEntries(
    [
      "Freedom Pines Seeds",
      "Skokie 10s Bench",
      "Skokie 20s Bench",
      "Skokie 30s Bench",
      "Skokie 70s Bench",
      "Skokie 80s Bench",
      "Skokie 90s Bench",
    ].map((key) => [key, DEFAULT_SEED_METRICS]),
  ),
  System: {
    "*": [
      {
        tag: "pH_BR",
        units: "pH",
      },
      {
        tag: "AgitAmp",
        units: "A",
      },
      {
        tag: "Level dP",
        units: "kPa",
      },
      {
        tag: "P_Head1",
        units: "kPa",
      },
      {
        tag: "Temp",
        units: "°C",
      },
    ],
    "AM Ghent Systems": [
      {
        tag: "Temp",
        units: "°C",
      },
      {
        tag: "pH",
        units: "pH",
      },
      {
        tag: "LGR_IN_HCN",
        units: "ppm",
      },
      {
        tag: "LGR_IN_H2S",
        units: "ppm",
      },
      {
        tag: "LGR_IN_Ammonia",
        units: "ppm",
      },
      {
        tag: "LGR_IN_C2H2",
        units: "ppm",
      },
      {
        tag: "LVL_pct",
        units: "pct",
      },
      {
        tag: "PW",
        units: "m3/hr",
      },
      {
        tag: "PSA_TAIL_CO",
        units: "pct",
      },
      {
        tag: "PSA_TAIL_CO2",
        units: "pct",
      },
      {
        tag: "PSA_TAIL_H2",
        units: "pct",
      },
      {
        tag: "PSA_TAIL_N2",
        units: "pct",
      },
      {
        tag: "FOAM_DT1",
        units: "pct",
      },
      {
        tag: "DEGAS_XV_BR1",
        units: "open",
      },
      {
        tag: "DEGAS_XV_BR2",
        units: "open",
      },
      {
        tag: "BS_Broth_IN_VOL_BR1",
        units: "m3/hr",
      },
      {
        tag: "BS_Broth_IN_VOL_BR2",
        units: "m3/hr",
      },
      {
        tag: "P_Gas",
        units: "barg",
      },
      {
        tag: "XMED",
        units: "m3/hr",
      },
      { tag: "Level", units: "mm" },
      {
        tag: "P_Gas",
        units: "barg",
      },
      {
        tag: "MS_Flow_OUT",
        units: "m3/hr",
      },
      {
        tag: "QG_PSA_OUT",
        units: "Nm3/hr",
      },
    ],
  },
}
// Default metrics shown in Report Generation modal (if different from KPI panel metrics)
export const REPORT_GEN_METRICS = {
  "AM Ghent": [
    { tag: "QG_VOL_FLOW", units: "Nm3/hr", min: 0, max: 20000 },
    { tag: "UCO", units: "pct", min: 0, max: 150 },
    { tag: "UH2", units: "pct", min: -50, max: 150 },
    { tag: "Ins_Pr_Eth_All_offline", units: "kg/hr", min: 0, max: 5000 },
    { tag: "Bleed", units: "m3/hr", min: 0, max: 30 },
    { tag: "Ethanol_2nd", label: "Ethanol - offline", units: "g/L", min: 0, max: 50 },
    { tag: "Acetate_2nd", label: "Acetate - offline", units: "g/L", min: 0, max: 50 },
    { tag: "OD", units: "g/L", min: 0, max: 50 },
    { tag: "BDO_2nd", label: "BDO - offline", units: "g/L", min: 0, max: 50 },
    { tag: "1-Butanol_2nd", label: "1-Butanol - offline", units: "g/L", min: 0, max: 50 },
    { tag: "VD_Rtn_Ethanol_2nd", label: "VD_Rtn_Ethanol - offline", units: "g/L", min: 0, max: 50 },
    { tag: "VD_Rtn_1-Butanol_2nd", label: "VD_Rtn_1-Butanol - offline", units: "g/L", min: 0, max: 50 },
    { tag: "Ins_Eth_Electron_Sel", units: "pct" },
    { tag: "Ins_Ace_Electron_Sel", units: "pct" },
    { tag: "Ins_BIOMASS_Electron_Sel", units: "pct" },
    { tag: "Ins_BDO_Electron_Sel", units: "pct" },
    { tag: "Ins_1BUT_Electron_Sel", units: "pct" },
    { tag: "Ins_CH4_Electron_Sel", units: "pct" },
    { tag: "Electron_Bal_Out_In", units: "pct" },
    { tag: "Carbon_Bal", units: "pct" },
  ],
  System: {},
}
